import React from "react";
import ReactCalendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { startOfYear, endOfYear, eachMonthOfInterval } from "date-fns";
import "./YearlyView.css";

const YearlyView = ({ selectedDate, setSelectedDate, events = [] }) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // normalize once

  // Normalize event dates for quick lookup
  const eventDates = new Set(
    events.map((e) => {
      const d = new Date(e.date);
      d.setHours(0, 0, 0, 0);
      return d.getTime();
    })
  );

  const months = eachMonthOfInterval({
    start: startOfYear(today),
    end: endOfYear(today),
  });

  return (
    <div className="yearly-view">
      {months.map((month) => (
        <div key={month.toISOString()} className="year-calendar-month">
          <ReactCalendar
            // ❌ remove value={selectedDate}
            onChange={setSelectedDate}
            locale="en-GB"
            prev2Label={null}
            next2Label={null}
            showNeighboringMonth={false}
            activeStartDate={month} // lock calendar to that month
            view="month"
            formatShortWeekday={(locale, date) =>
              date.toLocaleDateString(locale, { weekday: "short" }).slice(0, 1)
            }
            tileClassName={({ date, view }) => {
              if (view !== "month") return null;

              const d = new Date(date);
              d.setHours(0, 0, 0, 0);

              // ✅ highlight event dates as selected
              if (eventDates.has(d.getTime())) return "event-date";

              // ❌ remove current-date highlight
              // if (d.getTime() === today.getTime()) return "is-today";

              if (d < today) return "past-date";
              if (date.getDay() === 0 || date.getDay() === 6) return "weekend";
              return null;
            }}
            tileDisabled={({ date, view }) => {
              if (view !== "month") return false;
              const d = new Date(date);
              d.setHours(0, 0, 0, 0);
              return d < today;
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default YearlyView;
